<template>
  <div class="planner">
    <div class="planner__back">
      <router-link to="/">
        <vm-icon icon="arrow-back-outline" size="2rem"></vm-icon>
      </router-link>
    </div>
    <div class="planner__theme-toggle">
      <vm-button
        @click="toggleTheme"
        :icon="theme === 'light' ? 'moon-outline' : 'sun-outline'"
        rounded
      />
    </div>
    <div class="planner__location">
      <h1>
        {{ branch_name }}

      </h1>
    </div>
    <div class="planner__search">
      <!-- barra de busqueda donde se filtra por folio, nombre -->
      <vm-input ref="search" icon="search" size="small" class="planner__search-input" :placeholder="searchPlaceholder" v-model="filters.params" @keyup.enter="applyFilter(filters.params)"  />
      <vm-select placeholder='Selecciona una sucursal'  v-model="filters.warehouse" class="planner__search-select" autocomplete @change="applyFilter()">
        <vm-select-item :key="index" :value="item" :text="item" v-for="(item,index) in warehousesOptions" />
      </vm-select>
      <vm-button v-if="filters.params || filters.warehouse" icon="close-outline" size="small" @click="clearFilters" />
    </div>

    <div class="planner__sections">
      <SectionColumn
        class="section-column"
        :title="$t('planner.to_be_delivered')"
        :orders="orders_to_be_delivered"
      />
      <SectionColumn
        class="section-column"
        :title="$t('planner.to_be_shipped_parcel')"
        :orders="orders_to_be_shipped_parcel"
      />
      <SectionColumn
        class="section-column"
        :title="$t('planner.to_be_shipped_deliveryman')"
        :orders="orders_to_be_shipped_deliveryman"
      />
      <SectionColumn
        class="section-column"
        :title="$t('planner.to_be_shipped_pick_up')"
        :orders="orders_to_be_shipped_pick_up"
      />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import SectionColumn from '@/components/planner/SectionColumn.vue'
const { mapGetters, mapActions } = createNamespacedHelpers('Planner')

export default {
  name: 'Planner',
  components: {
    SectionColumn
  },
  data () {
    return {
      branch_name: '',
      orders_to_be_delivered: [],
      orders_to_be_shipped_parcel: [],
      orders_to_be_shipped_deliveryman: [],
      orders_to_be_shipped_pick_up: [],
      order_completed: 3,
      without_shipped_status: 0,
      parcel: 1,
      deliveryman: 2,
      pick_up: 3,
      interval: null,
      currentTheme: 'light',
      searchPlaceholder: 'Buscar por folio o nombre',
      filters: {
        params: '',
        warehouse: ''
      },
      orderData: []
    }
  },
  computed: {
    ...mapGetters(['orders', 'warehousesOptions']),
    theme () {
      return this.currentTheme
    }
  },
  async created () {
    this.branch_name = this.$auth.user().branch
      ? this.$auth.user().branch.name
      : this.$t('planner.all_branches')
    await this.loadDefaultOrders()
    this.orderData = this.orders
    this.refreshOrders()
    this.startInterval()
  },
  mounted () {
    const elements = document.getElementsByClassName('background--transition')
    if (elements.length > 0) elements[0].style.paddingTop = '20px'

    this.initializeThemeLocal()
  },
  beforeDestroy () {
    this.stopInterval()
    const elements = document.getElementsByClassName('background--transition')
    if (elements.length > 0) elements[0].style.paddingTop = '70px'
  },

  methods: {
    ...mapActions([
      'loadOrders',
      'loadDefaultOrders'
    ]),
    initializeThemeLocal () {
      console.log('Inicializando tema local')
      const storedTheme = localStorage.getItem('theme') || 'light'
      console.log('Tema guardado:', storedTheme)
      this.setThemeLocal(storedTheme)
    },
    setThemeLocal (theme) {
      console.log('Estableciendo tema local:', theme)
      this.currentTheme = theme

      localStorage.setItem('theme', theme)

      const body = document.body
      body.classList.remove('light', 'dark')
      body.classList.add(theme)

      console.log('Tema aplicado:', theme)
    },
    toggleTheme () {
      console.log('toggleTheme actual:', this.currentTheme)
      const newTheme = this.currentTheme === 'light' ? 'dark' : 'light'
      console.log('Cambiando a:', newTheme)
      this.setThemeLocal(newTheme)
    },
    refreshOrders () {
      if (this.orders.length > 0) {
        this.orders_to_be_delivered = this.orderData.filter(
          order => order.status != this.order_completed

        )
        const orders_completed = this.orderData.filter(
          order => order.status == this.order_completed
        )
        this.orders_to_be_shipped_parcel = orders_completed.filter(
          order =>
            order.send_type == this.parcel ||
            order.send_type == this.without_shipped_status
        )
        this.orders_to_be_shipped_deliveryman = orders_completed.filter(
          order => order.send_type == this.deliveryman
        )
        this.orders_to_be_shipped_pick_up = orders_completed.filter(
          order => order.send_type == this.pick_up
        )
      }
    },
    async loadAndRefreshOrders () {
      await this.loadOrders()
      this.orderData = this.orders
      this.applyFilter()
    },
    async startInterval () {
      await this.loadAndRefreshOrders()
      this.interval = setInterval(async () => {
        await this.loadAndRefreshOrders()
      }, 120000)
    },
    stopInterval () {
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
    },
    applyFilter () {
      console.log('applyFilter', this.filters)
      if (this.filters.params && this.filters.params.trim() !== '') {
        const filterLower = this.filters.params.toLowerCase()

        this.orderData = this.orders.filter(order => {
          const folio = String(order.folio).toLowerCase()
          const nombre = (order.customer || '').toLowerCase() // asegúrate que exista "nombre"

          return (
            folio.includes(filterLower) ||
            nombre.includes(filterLower)
          )
        })
      } else {
        this.orderData = this.orders
      }

      if (this.filters.warehouse && this.filters.warehouse.trim() !== '') {
        this.orderData = this.orders.filter(order => order.warehouse_names.includes(this.filters.warehouse))
      }

      if (!this.filters.params && !this.filters.warehouse) {
        this.orderData = this.orders
      }

      this.refreshOrders()
    },
    clearFilters () {
      this.filters.params = ''
      this.filters.warehouse = ''
      this.applyFilter()
    }
  }
}
</script>

<style lang="scss">
.planner {
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0 12px;

  &__back {
    position: absolute;
    top: 12px;
    left: 12px;
  }

  &__theme-toggle {
    position: absolute;
    bottom: 12px;
    right: 12px;
    z-index: 1000;
  }

  &__location {
    text-align: center;
    font-size: 1.5rem;
    padding-bottom: 12px;
  }

  &__sections {
    display: flex;
    width: 100vw;
    overflow-x: auto;

    &__section-column:not(:last-child) {
      border-right: 2px solid rgba(0, 0, 0, 0.15);
    }
  }
  &__search {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    &-input {
      width: 400px;
    }
    &-select {
      width: 200px !important;
    }
  }
}

body.dark .planner {
  background-color: #232323;
  color: #ffffff;
}
</style>
